const initMuteToggles = () => {
  document.querySelectorAll('.mute-toggle').forEach((button) => {
    if (button.dataset.listenerAttached) return;
    button.dataset.listenerAttached = 'true';

    const wrapper = button.closest('.group');
    if (!wrapper) return;

    const video = wrapper.querySelector('video');
    if (!video) return;

    const mutedIcon = button.querySelector('.icon-muted');
    const unmutedIcon = button.querySelector('.icon-unmuted');

    button.addEventListener('click', () => {
      video.muted = !video.muted;
      video.play().catch(() => {});

      mutedIcon?.classList.toggle('hidden', !video.muted);
      unmutedIcon?.classList.toggle('hidden', video.muted);
    });
  });
};

/**
 * Auto-init on DOM ready
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMuteToggles);
} else {
  initMuteToggles();
}

export default initMuteToggles;
